export const DEFAULT_CHAT_TITLE = "New conversation";
export const WORKSPACE_GLOBAL_CHAT_LABEL = "Chat";
export const BACK_TO_GLOBAL_CHAT_LABEL = "Back to chat";
